import { BaseService } from '@services/BaseService'

const resource = 'hr/travelhistory'

class TravelHistoryService extends BaseService {
  constructor() {
    super(resource)
  }
}

export const travelHistoryService = new TravelHistoryService()
